import modalConfirmation from '../../shared/components/modal-response/modal-response.view.html';
// let inject = [
//   '$scope',
//   'DetailZoneService',
//   '$state',
//   '$rootScope',
//   'SharedService',
//   '$uibModal',
//   'DetailedPaymentService',
//   'AdvanceService'
// ];
let inject = [
  '$scope',
  'DetailZoneService',
  '$state',
  '$rootScope',
  'SharedService',
  '$uibModal',
  'DetailedPaymentService'
];

class DetailZoneController{
  // constructor ($scope, DetailZoneService, $state, $rootScope, SharedService, $uibModal, DetailedPaymentService, AdvanceService) {
  constructor ($scope, DetailZoneService, $state, $rootScope, SharedService, $uibModal, DetailedPaymentService) {
    this.$state = $state;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.DetailedPaymentService = DetailedPaymentService;
    // this.AdvanceService = AdvanceService;
    this.$uibModal = $uibModal;
    this.DetailZoneService = DetailZoneService;
    this.SharedService = SharedService;
    this.loanding = false;
    this.plant = [];
    this.concepts = [];
    this.advance = {};
    this.conceptSelected = null;
    this.openModal = false;
    this.conceptSelected = 2;
  }

  $onInit(){
    this.getDatas();
  }
  
  getDatas() {
    this.DetailZoneService.getConcepts().then(response => {
      this.concepts = response;
      // let payment = this.AdvanceService.getPayment();
      // if(payment) {
      //   this.plant = payment.plant;
      //   this.advance = payment.advance;
      //   this.conceptSelected = payment.concepto_id;
      // }
      let thirdDocumentNumber = '';
      try{
        thirdDocumentNumber = this.shCtrl.globals.currentUser.thirdDocumentNumber;
      } catch (e) {
      
      }
      this.DetailZoneService.getBriefcase(thirdDocumentNumber).then(response => {
        this.briefcase = response;
      });
    });
    
  }
  
  submitPayment() {
    if(this.conceptForm.$valid) {
      let today = new Date();
      today = today.toISOString().substring(0,10);
      if(angular.isString(this.advance.valor)) {
        this.advance.valor = this.advance.valor.replace(/[,]/g, '');
        this.advance.valor = parseInt(this.advance.valor);
      }
      let result = {
        advance : this.advance,
        plant : this.plant,
        concepto_id : this.conceptSelected,
        centro_operacion_id : this.plant.id,
        centro_operacion_code : this.reference,
        recaudo_total : this.advance.valor,
        observaciones : this.advance.reference,
        usuario_creacion : this.shCtrl.globals.currentUser.userId,
        fecha_creacion : today,
        facturas : null
      };
      if(this.conceptSelected === 1) {
        // this.AdvanceService.setPayment(result);
        // $location.path('/zona-de-pagos/anticipo');
      } else {
        this.DetailedPaymentService.setPayment(result);
        this.$state.go('home.detailedPayment');
      }
      
    }
  }

  messageResponse (options, callAcept, callback, callCancel, callbackCancel) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalConfirmation,
      controller : 'ModalResponseController',
      controllerAs : 'mdCtrl',
      size: options.size,
      resolve : {
        modalOptions : () => options
      }
    });
    modalInstance.result.then(() => {
      if(callAcept) {
        callback();
      }
    }).catch(reason => {
      if(callCancel) {
        callbackCancel();
      }
    });
  }
}

DetailZoneController.$inject = inject;

export default DetailZoneController;




// WEBPACK FOOTER //
// ./www/components/pay-zone/detail-zone/detail-zone.controller.js